import lodash from 'src/utils/lodash'

export const isEqual = lodash.isEqual
